import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import User from "./User";
import Group from "./Group";
import GroupUser from "./GroupUser";
import Avatar from "./Avatar";
import Entry from "./Entry";
import EntrySuggestion from "./EntrySuggestion";
import Project from "./Project";
import ProjectUser from "./ProjectUser";
import ProjectGroup from "./ProjectGroup";
import ProjectTagList from "./ProjectTagList";
import ProjectTag from "./ProjectTag";
import ProjectInvoice from "./ProjectInvoice";
import Phase from "./Phase";
import PhaseCategory from "./PhaseCategory";
import Expense from "./Expense";
import ExpenseCategory from "./ExpenseCategory";
import Timer from "./Timer";
import Account from "./Account";
import Metric from "./Metric";
import StatsTemplate from "./StatsTemplate";
import Language from "./Language";
import Currency from "./Currency";
import Country from "./Country";
import Zone from "./Zone";
import SubscriptionType from "./SubscriptionType";
import AccountIntegration from "./AccountIntegration";
import UserIntegration from "./UserIntegration";
import UserSource from "./UserSource";
import Source from "./Source";
import TagList from "./TagList";
import Tag from "./Tag";
import Experiment from "./Experiment";
import Note from "./Note";
import StatsAccount from "./StatsAccount";
import Invoice from "./Invoice";
import Notification from "./Notification";
import Client from "./Client";
import Budget from "./Budget";
import EntryTag from "./EntryTag";
import TimerTag from "./TimerTag";
import Report from "./Report";
import AnalyticsEvent from "./AnalyticsEvent";
import Campaign from "./Campaign";
import Integration from "./Integration";
import Todo from "./Todo";
import TodoList from "./TodoList";
import TagTodo from "./TagTodo";
import Feature from "./Feature";
import AccountFeature from "./AccountFeature";
import ApprovalRequest from "./ApprovalRequest";
import ApprovalEvent from "./ApprovalEvent";
Vue.use(Vuex); // Create new instance of Database.

var database = new VuexORM.Database(); // Register Model and Module. The First argument is the Model, and
// second is the Module.

database.register(User);
database.register(Group);
database.register(GroupUser);
database.register(Avatar);
database.register(Entry);
database.register(EntrySuggestion);
database.register(Project);
database.register(ProjectUser);
database.register(ProjectGroup);
database.register(ProjectTagList);
database.register(ProjectTag);
database.register(ProjectInvoice);
database.register(Phase);
database.register(PhaseCategory);
database.register(Expense);
database.register(ExpenseCategory);
database.register(Timer);
database.register(Account);
database.register(Metric);
database.register(StatsTemplate);
database.register(Language);
database.register(Currency);
database.register(Country);
database.register(Zone);
database.register(SubscriptionType);
database.register(AccountIntegration);
database.register(UserIntegration);
database.register(UserSource);
database.register(Source);
database.register(Notification);
database.register(TagList);
database.register(Tag);
database.register(Experiment);
database.register(Note);
database.register(StatsAccount);
database.register(Invoice);
database.register(Client);
database.register(Budget);
database.register(EntryTag);
database.register(TimerTag);
database.register(Report);
database.register(AnalyticsEvent);
database.register(Campaign);
database.register(Integration);
database.register(Todo);
database.register(TodoList);
database.register(TagTodo);
database.register(Feature);
database.register(AccountFeature);
database.register(ApprovalRequest);
database.register(ApprovalEvent);
export default database;